import React, { useCallback, useEffect, useState } from 'react';

import {
  Container,
  Button,
  TextField,
  Modal,
  Paper,
  Toolbar,
  Typography,
  IconButton,
} from '@material-ui/core';

import {
  Close,
} from '@material-ui/icons';

import {
  DropzoneArea,
} from 'material-ui-dropzone';

import {
  useStore,
} from '../../store';

import {
  LoadingButton,
  Image,
} from '../index';

import useStyles from './styles';

export function ModalDocument() {
  const Styles = useStyles();

  const {
    alert,
    document,
  } = useStore();

  const [ name, setName ] = useState('');
  const [ file, setImage ] = useState( null );

  const [ showFile, setShowFile ] = useState( false );

  const handleSave = useCallback( async () => {
    const formData = new FormData();

    formData.append('name', name );
    formData.append('file', file );

    const { success, message } = await document.handleSave( formData );

    alert.openAlert( success, message );

    if( success)
      document.handleCloseModal();
  }, [ name, file ]);

  useEffect(() => {
    if( !document.isOpenModal ) {
      setName('');
    } else {
      if( document.document ) {
        setName( document.document.name );
      }
    }
  }, [ document.isOpenModal, document.document ]);

  return (
    <>
      <Modal
        open={ document.isOpenModal }
        onClose={ document.handleCloseModal }
        className={ Styles.modal }
      >
        <Paper className={ Styles.modalView }>
          <Toolbar className={ Styles.modalToolbar }>
            <Typography
              noWrap
              className={ Styles.modalTitle }
              variant="h6"
            >
              {`${ document.document?.function || 'Adicionar'} Documento`}
            </Typography>
          </Toolbar>

          <Container className={ Styles.bodyModal }>
            {
              document.document?.function === 'Excluir'
                ? <>
                    <Typography className={ Styles.question } component="h5">
                      Deseja realmente excluir o documento
                    </Typography>

                    <Typography component="h5">
                      { document.document?.name }?
                    </Typography>
                  </>
                : <>
                    <TextField
                      className={ Styles.input }
                      label="Nome"
                      placeholder="Nome"
                      variant="outlined"
                      value={ name }
                      onChange={ event => setName( event.target.value )}
                    />

                    <DropzoneArea
                      dropzoneText={"Documento, arraste ou clique"}
                      dropzoneParagraphClass={ Styles.dropZoneText }
                      onChange={( files ) => {
                        setImage( files[ 0 ])
                      }}
                      showPreviews={ true }
                      showPreviewsInDropzone={ false }
                      previewText="Documento selecionado"
                      showAlerts={ false }
                      filesLimit={ 1 }
                      classes={{
                        root: Styles.dropZone
                      }}
                    />

                    { document.document?.file && (<Button style={{ marginTop: 16 }} onClick={() => setShowFile( true )}>Ver Documento</Button>)}
                  </>
            }

            <Container className={ Styles.modalActions }>
              <Button
                variant="outlined"
                color="inherit"
                onClick={ document.handleCloseModal }
              >
                { document.document?.function === 'Excluir' ? 'Não' : 'Cancelar'}
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={ handleSave }
                disabled={ document.document?.function !== 'Excluir' &&
                  (document.saving || (!name || (!file && !Boolean(document.document?._id))) || name === document.document?.name)
                }
              >
                { document.document?.function === 'Excluir' ? 'Sim' : 'Salvar'}

                { document.saving && <LoadingButton />}
              </Button>
            </Container>
          </Container>
        </Paper>
      </Modal>

      <Modal
        open={ showFile }
        onClose={() => setShowFile( false )}
        className={ Styles.modal }
      >

        <Paper className={ Styles.modalViewFile }>
          <Toolbar className={ Styles.modalToolbar }>
            <Typography
              noWrap
              className={ Styles.modalTitle }
              variant="h6"
            >
              Documento
            </Typography>

            <IconButton
              onClick={() => setShowFile( false )}
              color="inherit"
            >
              <Close />
            </IconButton>
          </Toolbar>

          <object style={{ width: '100%', height: '100%'}} data={`${ process.env.REACT_APP_API_URL }/file/document/${ document.document?.file }`}></object>
        </Paper>
      </Modal>
    </>
  );
};
